import React, { useState } from "react";
import Slider from "react-slick/lib/slider";
import ImageFadeIn from "react-image-fade-in";
import { NextArrow, PrevArrow } from "components/Common/Arrows";
import "./product-preview-slider-theme2.scss";

const ProductPreviewSliderTheme2 = ({ image, gallery, onZoom, onImageClick , brand_icon}) => {
  const [activeSlide, setActiveSlide] = useState();

  const handleSlider = (slide) => {
    setActiveSlide(slide);
  };
  const settings = {
    dots: false,
    infinite: false,
    speed: 10,
    slidesToShow: 4,
    vertical: true,
    verticalSwiping: true,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 1340,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: false,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
    ],
  };
  const hasChildImages = gallery.some(slide => slide.file);
  return (
    <div className="product-preview-slider-theme2">
      {hasChildImages && (
        <div className="child-images">
          <Slider {...settings}>
            {gallery.map((slide, index) => (
              <div key={index} className={activeSlide === slide.file ? "active procut-child-image" : "procut-child-image"}>
                <img
                  src={slide.file}
                  alt="ChildProductImage"
                  onClick={() => handleSlider(slide.file)}
                  onMouseEnter={() => handleSlider(slide.file)}
                />
              </div>
            ))}
          </Slider>
        </div>
      )}
      <div 
        className="selected-product"
        onMouseMove={(e) => {
          const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
          const x = ((e.clientX - left) / width) * 100;
          const y = ((e.clientY - top) / height) * 100;
          onZoom && onZoom({ show: true, x, y, image: activeSlide || image });
        }}
        onMouseEnter={() => onZoom && onZoom({ show: true, image: activeSlide || image })}
        onMouseLeave={() => onZoom && onZoom({ show: false })}
        onClick={() => onImageClick && onImageClick(activeSlide || image)}
      >
        <ImageFadeIn src={activeSlide || image} />
         {brand_icon && brand_icon !== "" && (
              <img src={brand_icon} alt="Brand Image" className="brand-icon" />
        )}
        <button 
          className="zoom-icon-btn"
          onClick={(e) => {
            e.stopPropagation();
            onImageClick && onImageClick(activeSlide || image);
          }}
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 3 21 3 21 9"></polyline>
            <polyline points="9 21 3 21 3 15"></polyline>
            <line x1="21" y1="3" x2="14" y2="10"></line>
            <line x1="3" y1="21" x2="10" y2="14"></line>
          </svg>
        </button>
      </div>
    </div>
  );
};
export default ProductPreviewSliderTheme2;
